module.exports = __webpack_public_path__ + "media/images/icon-period-close@3x-bad6abedcd50ebfc3ffa75adc4077cd8.png";